<template>
  <article :class="['date-period-filter', { 'date-period-filter_flat': flat }]">
    <div class="filters-container">
      <div class="date-filter mr-4">
        <div class="date-period-filter__label">
          выбрать <br> дату:
        </div>
        <div class="date-picker-block stat-filter-col__content">
          <slot name="date-picker">
            <v-menu
              ref="menu"
              v-model="menu"
              :return-value.sync="datesRange"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  class="button-datepicker"
                  height="48"
                  color="#fff"
                  depressed
                  v-on="on"
                >
                  <font-awesome-icon
                    color="#FF9100"
                    icon="calendar-alt"
                  />
                  <span class="d-flex font-weight-light">
                    {{ fromDateFormatted }} - {{ toDateFormatted }}
                  </span>
                </v-btn>
              </template>
              <div class="datepicker">
                <v-date-picker
                  v-model="datesRange"
                  event-color="#FF9D00"
                  :first-day-of-week="1"
                  no-title
                  locale="ru"
                  reactive
                  range
                  @change="$refs.menu.save(datesRange)"
                >
                </v-date-picker>
              </div>
            </v-menu>
          </slot>
        </div>
      </div>

      <v-btn
        class="date-period-filter__apply-btn"
        depressed
        color="#D3D5D9"
        @click="applyFilter"
      >
        Применить
      </v-btn>
    </div>

    <div
      v-if="!hideDaysDiff && daysDiff"
      class="date-period-filter__days-diff"
    >
      <span class="days-diff_label">вывод: </span>
      <span class="days-diff_value">{{ daysDiff }}</span>
      {{ daysDiffLabel }}
    </div>
  </article>
</template>

<script>
  import moment from 'moment'
  import { numWord } from '@/util/string'
  import snackbarMessage from '@/mixins/snackbar-message'
  import { DateTime } from 'luxon'

  export default {
    name: 'DatePeriodFilter',
    mixins: [snackbarMessage],
    props: {
      daysCount: {
        type: Number,
        default: 15,
      },
      lastYear: {
        type: Boolean,
        default: false,
      },
      endDate: {
        type: String,
        default: null,
      },
      startDate: {
        type: String,
        default: null,
      },
      hideDaysDiff: {
        type: Boolean,
        default: false,
      },
      flat: { // без собственной подложки — когда фильтр встроен в чужой блок
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        showDatepicker: false,
        datesRange: [],
        menu: false,
      }
    },
    computed: {
      fromDateMoment () {
        return moment(this.datesRange[0], 'YYYY-MM-DD')
      },
      toDateMoment () {
        return moment(this.datesRange[1], 'YYYY-MM-DD')
      },
      fromDateFormatted () {
        return this.fromDateMoment.isValid() ? this.fromDateMoment.format('DD.MM.YYYY') : '__.__.__'
      },
      toDateFormatted () {
        return this.toDateMoment.isValid() ? this.toDateMoment.format('DD.MM.YYYY') : '__.__.__'
      },
      daysDiff () {
        if (this.fromDateMoment.isValid() && this.toDateMoment.isValid()) {
          return this.toDateMoment.diff(this.fromDateMoment, 'days') + 1
        } else {
          return ''
        }
      },
      daysDiffLabel () {
        return this.daysDiff ? numWord(this.daysDiff, 'день', 'дня', 'дней') : ''
      },
      filterData () {
        return {
          from: this.datesRange[0],
          to: this.datesRange[1],
        }
      },
    },
    created () {
      this.initFilterData()
      this.applyFilter()
    },
    methods: {
      initFilterData () {
        let startDate, endDate
        if (this.startDate && this.endDate) {
          startDate = this.startDate
          endDate = this.endDate
        } else if (this.lastYear) {
          startDate = moment().startOf('year').format('YYYY-MM-DD')
          endDate = DateTime.now().toFormat('yyyy-LL-dd')
        } else if (this.startDate) {
          startDate = this.startDate
          endDate = moment(startDate, 'YYYY-MM-DD')
            .add(this.daysCount - 1, 'days')
            .format('YYYY-MM-DD')
        } else {
          endDate = this.endDate || moment().format('YYYY-MM-DD')
          startDate = moment(endDate, 'YYYY-MM-DD')
            .subtract(this.daysCount - 1, 'days')
            .format('YYYY-MM-DD')
        }

        this.datesRange = [startDate, endDate]
      },
      applyFilter () {
        if (this.validate()) {
          this.$emit('apply', this.filterData)
        }
      },
      validate () {
        if (this.fromDateMoment.isValid() && this.toDateMoment.isValid() &&
          this.toDateMoment.diff(this.fromDateMoment, 'days') >= 0) {
          this.showDatepicker = false
          return true
        } else {
          this.showErrorMessage('Выберите корректный диапазон дат')
          return false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.date-period-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 15px;
  background: #F1F3F6;
  border-radius: 10px;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: flex-start;
  }

  &_flat {
    padding: 0;
    background: transparent;
    border-radius: 0;
  }

  &__label {
    line-height: 1.1;
    margin-right: 15px;
    color: #949191;

    @media (max-width: 550px) {
      margin-bottom: 10px;
      display: block;

      br {
        display: none;
      }
    }
  }

  .date-picker-block {
    position: relative;

    .button-datepicker {
      font-size: 14px;
      border-radius: 10px;

      span {
        font-size: 12px;
        font-weight: 400;
      }

      svg {
        margin-right: 5px;
      }
    }

    .datepicker {
      position: absolute;
      left: 0;
      top: calc(100% + 5px);
      z-index: 10000;
    }
  }

  &__apply-btn {
    border-radius: 10px;

    @media (max-width: 550px) {
      margin-bottom: 4px;
    }
  }

  &__days-diff {
    .days-diff__label {
      color: #B9BABB;
    }

    .days-diff_value {
      color: #E91E63;
    }
  }
}

.filters-container {
  display: flex;
  align-items: center;

  @media (max-width: 550px) {
    align-items: flex-end;
    margin-bottom: 10px;
  }
}

.date-filter {
  display: flex;
  align-items: center;

  @media (max-width: 550px) {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
